import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { foMonAnChiTietApi } from "../../../api/dich-vu/food/foMonAnChiTietApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eFoMonAnChiTietActionTypeIds,
	IFoMonAnChiTietDeleteStart,
	IFoMonAnChiTietLoadDetailStart,
	IFoMonAnChiTietLoadStart,
	IFoMonAnChiTietSaveStart
} from "../../action-types/dich-vu/IFoMonAnChiTietActionTypes";
import { foMonAnChiTietActions } from "../../actions/dich-vu/foMonAnChiTietActions";

export function* foMonAnChiTietSaga(): any {
	yield takeLatest(eFoMonAnChiTietActionTypeIds.LOAD_START, loadFoMonAnChiTietWorker)
	yield takeLatest(eFoMonAnChiTietActionTypeIds.LOAD_DETAIL_START, loadFoMonAnChiTietDetailWorker)
	yield takeEvery(eFoMonAnChiTietActionTypeIds.SAVE_START, saveFoMonAnChiTietWorker)
	yield takeEvery(eFoMonAnChiTietActionTypeIds.DELETE_START, deleteFoMonAnChiTietWorker)
}

function* loadFoMonAnChiTietWorker(action: IFoMonAnChiTietLoadStart): any {
	const res: IBaseResponeModel = yield call([foMonAnChiTietApi, foMonAnChiTietApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(foMonAnChiTietActions.loadFoMonAnChiTietSuccess(res.data || []))
	} else {
		yield put(foMonAnChiTietActions.loadFoMonAnChiTietError(res.message || "Không tải được danh sách món ăn"))
	}
}

function* loadFoMonAnChiTietDetailWorker(action: IFoMonAnChiTietLoadDetailStart): any {
	const res: IBaseResponeModel = yield call([foMonAnChiTietApi, foMonAnChiTietApi.SelectById], action.payload)
	if (res.is_success && res.data) {
		yield put(foMonAnChiTietActions.loadFoMonAnChiTietDetailSuccess(res.data))
	} else {
		yield put(foMonAnChiTietActions.loadFoMonAnChiTietDetailError(res.message || "Không tải được thông tin món ăn"))
	}
}

function* saveFoMonAnChiTietWorker(action: IFoMonAnChiTietSaveStart): any {
	let res: IBaseResponeModel;
	const is_update = action.payload.id > 0;
	if (is_update) {
		res = yield call([foMonAnChiTietApi, foMonAnChiTietApi.Update], action.payload);
	} else {
		res = yield call([foMonAnChiTietApi, foMonAnChiTietApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(foMonAnChiTietActions.saveFoMonAnChiTietSuccess(is_update))
	} else {
		yield put(foMonAnChiTietActions.saveFoMonAnChiTietError(res.message || "Không lưu được món ăn"))
	}
}

function* deleteFoMonAnChiTietWorker(action: IFoMonAnChiTietDeleteStart): any {
	const res: IBaseResponeModel = yield call([foMonAnChiTietApi, foMonAnChiTietApi.Delete], action.payload)
	if (res.is_success) {
		yield put(foMonAnChiTietActions.deleteFoMonAnChiTietSuccess())
	} else {
		yield put(foMonAnChiTietActions.deleteFoMonAnChiTietError(res.message || "Không xóa được món ăn"))
	}
}
